import lodashOrderBy from 'lodash/orderBy';
import dayjs from 'dayjs';
export class ContactDBFrequent {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async getRecentContact(params) {
        const indexes = [];
        for (let i = 0; i < params.pageSize; i++) {
            indexes.push((params.page - 1) * params.pageSize + i);
        }
        let res = await this.ctx.dbApi.getByIds({
            tableName: this.ctx.contactUtil.recentContactTable,
            dbName: this.ctx.contactUtil.contactDbName,
            _dbAccount: params._account,
        }, indexes);
        res = res.filter(_ => _);
        res &&
            res.length &&
            res.forEach(_ => {
                _ && delete _.index;
            });
        return res;
    }
    async saveRecentContactInDb(concatList, params) {
        concatList.forEach((concat, index) => {
            concat.index = (params.page - 1) * params.pageSize + index;
        });
        return this.ctx.dbApi
            .putAll({
            tableName: this.ctx.contactUtil.recentContactTable,
            dbName: this.ctx.contactUtil.contactDbName,
            _account: params._account,
        }, concatList)
            .then();
    }
    async queryFrequentContact(params) {
        const { list, _account } = params;
        return this.ctx.dbApi.getByRangeCondition({
            dbName: 'contact_dexie',
            tableName: this.ctx.contactUtil.frequentContactTable,
            _dbAccount: _account,
            adCondition: {
                type: 'anyOf',
                field: ['contactId', 'channel'],
                args: [list],
            },
        });
    }
    async putFrequentContact(params) {
        const { list, _account } = params;
        return this.ctx.dbApi.putAll({
            dbName: 'contact_dexie',
            tableName: this.ctx.contactUtil.frequentContactTable,
            _dbAccount: _account,
        }, list);
    }
    async cleanExpiredFrequentContact(params) {
        const timestamp = dayjs().startOf('day').subtract(30, 'day').valueOf();
        const list = await this.ctx.dbApi.getByRangeCondition({
            dbName: 'contact_dexie',
            tableName: this.ctx.contactUtil.frequentContactTable,
            adCondition: {
                type: 'below',
                field: 'timestamp',
                args: [timestamp],
            },
            _account: params._account,
        });
        if (!list || !list.length) {
            return;
        }
        const ids = list.map(item => item.id);
        await this.ctx.dbApi.deleteById({
            dbName: 'contact_dexie',
            tableName: this.ctx.contactUtil.frequentContactTable,
            _account: params._account,
        }, ids);
    }
    async sortSearchResult(params) {
        const { list, query, orderBy, idKeypath = 'id' } = params;
        const { util } = await import('@/api/util');
        const defaultOrderList = util.setDataOrder({
            data: list,
            query,
            orderBy,
        });
        const defaultOrderMap = new Map();
        const { frequentChannel = 'mail', frequentOrderCount = 10, _account, handleSameIdType = 'replace' } = params;
        const lodashGet = (await import('lodash/get')).default;
        const queryIds = new Set();
        const flattenDataMap = new Map();
        defaultOrderList.forEach(item => {
            const id = lodashGet(item, `${idKeypath}`, '') || '';
            queryIds.add(util.getUnique(id, frequentChannel));
            defaultOrderMap.set(id, item);
            if (handleSameIdType === 'flatten') {
                if (!flattenDataMap.has(id)) {
                    flattenDataMap.set(id, []);
                }
                flattenDataMap.get(id).push(item);
            }
        });
        if (!params.useFrequentOrder) {
            const _list = [];
            defaultOrderMap.forEach((item, id) => {
                if (handleSameIdType === 'flatten' && flattenDataMap.has(id)) {
                    _list.push(...flattenDataMap.get(id));
                    return;
                }
                _list.push(item);
            });
            return {
                frequentOrderList: [],
                defaultOrderList: _list,
            };
        }
        const frequentTableRawData = await this.ctx.dbApi.getByIds({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.frequentContactTable,
            _dbAccount: _account,
        }, [...queryIds]);
        const frequentContactList = frequentTableRawData.filter(item => item);
        if (!frequentContactList || !frequentContactList.length) {
            const _list = [];
            defaultOrderMap.forEach((item, id) => {
                if (handleSameIdType === 'flatten' && flattenDataMap.has(id)) {
                    _list.push(...flattenDataMap.get(id));
                    return;
                }
                _list.push(item);
            });
            return {
                frequentOrderList: [],
                defaultOrderList: _list,
            };
        }
        const frequentOrderMap = new Map();
        const orderList = lodashOrderBy(frequentContactList, ['timestamp', 'sendcount'], ['desc', 'desc']);
        let startIndex = 0;
        while (startIndex < Math.min(orderList.length, frequentOrderCount)) {
            const { contactId } = orderList[startIndex];
            frequentOrderMap.set(contactId, defaultOrderMap.get(contactId));
            defaultOrderMap.delete(contactId);
            startIndex++;
        }
        const frequentOrderList = [];
        const _list = [];
        frequentOrderMap.forEach((item, id) => {
            if (handleSameIdType === 'flatten' && flattenDataMap.has(id)) {
                frequentOrderList.push(...flattenDataMap.get(id));
                return;
            }
            frequentOrderList.push(item);
        });
        defaultOrderMap.forEach((item, id) => {
            if (handleSameIdType === 'flatten' && flattenDataMap.has(id)) {
                _list.push(...flattenDataMap.get(id));
                return;
            }
            _list.push(item);
        });
        return {
            frequentOrderList,
            defaultOrderList: _list,
        };
    }
}
